<template>
    <div class="newimgs">
         <img :src="addressphoto" alt />
    </div>
</template>

<script>
export default {
    props:{
            addressphoto:{
      type:String,
      default:""
    },
    },
    data() {
        return {

        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>

<style scoped>
.newimgs{
    width: 100%;
}
.newimgs img{
    width: 100%;
}

</style>
